import { editPartner } from '../../../actions/siteadmin/editPartner';
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
    values.password = values.password ? values.password : undefined;
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    await dispatch(
        editPartner(
            values
        )
    )
}

export default submit;